//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';
import CryptomatFeesTable from './CryptomatFeesTable/CryptomatFeesTable.vue';
import CryptomatLimitsTable from './CryptomatLimitsTable/CryptomatLimitsTable.vue';

export default {
  components: {
    CryptomatFeesTable,
    CryptomatLimitsTable,
  },
  data() {
    return {
      constant,
    };
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadFees(),
      this.loadAtms(),
      this.loadAtmLimits(),
    ]);
    this.setGeneralLoader(false);
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('cryptomatsFees', ['fees']),
    ...mapState('cryptomatsAtms', ['atms', 'atmLimits', 'page', 'pages', 'filters']),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('cryptomatsFees', {
      loadFees: 'loadFees',
    }),
    ...mapActions('cryptomatsAtms', {
      loadAtms: 'loadAtms',
      loadAtmLimits: 'loadAtmLimits',
    }),
  },
};
